/* eslint indent: "off" */
import React, { useEffect, useRef, useState } from 'react';
import { Route, Routes, createBrowserRouter, Outlet, useLocation } from 'react-router-dom';
import MainWrapper from './MainWrapper';
import Layout from '../Layout/index';
import Register from '../Register/index';

// Login
import Landing from '../Landing/LogIn';
// import LoginCheck from '../Landing/loginCheck';

// Dashboard
import Home from '../Dashboard/index';

// Profile
import ChangePassword from '../Account/ChangePassword/index';
import ChangeRecoverPassword from '../Account/ChangeRecoverPassword/index';
import ForgotPassword from '../Account/ForgotPassword/index';
import LoginChangePassword from '../Account/LoginChangePassword/index';
import Profile from '../Account/Profile';

import EmailTemplate from '../Cruds/EmailTemplates';
import Roles from '../Cruds/Roles';
import Activities from '../Cruds/Activities'
import EmailStatus from '../Cruds/EmailStatus/index';
// Tables
import Employees from '../Cruds/Employees/index';
import Tickets from '../Cruds/Tickets/index.jsx';
import MyDrives from '../Cruds/MyDrives/index';
import Users from '../Cruds/Users/index';
import Homes from '../Cruds/Homes/index';
import Files from '../Cruds/Files/index';
import Folders from '../Cruds/Folders/index';
import SharedFiles from '../Cruds/SharedFiles/index';

// import Employees from '../Cruds/Employees/index';

import Settings from '../Cruds/Settings/index'
import AdminSettings from '../Settings/index'
import Uploads from '../Cruds/Uploads/index';
// 404 page not found 
import ErrorNotFound from '../Account/404/index';
import config from '../../config/config';
import SampleForm from '../../Sample/SampleForm.jsx';
import Verification from '../Landing/LogIn/components/index.jsx';
import GoogleAuthenticator from '../Landing/GoogleLogin/index.jsx';
import VerifyGoogleAuthenticator from '../Landing/GoogleLogin/components/index.jsx';
import Search from '../Cruds/Search/index.jsx';
import PublicAi from '../Cruds/PublicAIAssistant/index.jsx';
import ShareChat from '../Cruds/ShareChat.jsx/index.jsx';
import HomeNews from '../Cruds/HomeNews/index.jsx';
import VerifyEmail from '../Cruds/VerifyEmail/index.jsx';
import TranslateFiles from '../Cruds/TranslateFiles/index.jsx';
import CompareFiles from '../Cruds/CompareFiles/index.jsx';
import Trash from '../Cruds/Trash/index.jsx';
import Recordings from '../Cruds/Recordings/index.jsx';
import Clients from '../Cruds/Clients/index.jsx';
import FilesAnalysis from '../Cruds/FilesAnalysis/index.jsx';
import ContentGeneration from '../Cruds/ContentGeneration/index.jsx';
import { useChatbot } from '../../contexts/chatbotContext.jsx';
import TestCaseGenerator from '../Cruds/Test Cases/components/TestCaseGenerator.jsx';
import TrackingCustomer from '../Cruds/TrackingCustomer/index.jsx'
import PaymentDocumentation from '../Cruds/PaymentDocumentation/components/PaymentDocumentation.jsx';
import Invoices from '../Cruds/Invoices/index.jsx';
import PriceChangeTracker from '../Cruds/PriceChangeTracker/index.jsx';
import Company from '../Cruds/Company/index.jsx';
import Agreements from '../Cruds/Agreements/index.jsx';
import Dashboard from '../Cruds/Dashboard/index.jsx';
import AgreementFiles from '../Cruds/Agreements/components/AgreementFiles.jsx';
import UniqueCases from '../Cruds/UniqueCases/index.jsx';
import Contracts from '../Cruds/Contracts/index.jsx';
import SmartScreenBuilder from '../Cruds/SmartSCreenBuilders/index.jsx';
import SmartScreen from "../Cruds/SmartScreen/index.jsx"
import CasePredictAI from '../CasePredictAI/index.jsx';



const Tables = () => {
  let roles = localStorage.rolePermissions
    ? JSON.parse(localStorage.rolePermissions)
    : false;
  if (roles) {
    return (
      <>
        <Routes>
          <Route path='/sampleform'
            element={<SampleForm />}
          ></Route>
          <Route exact
            path="/employees"
            element={
              roles['Employees'] &&
                (roles['Employees'] === "Edit" || roles['Employees'] === "View")
                ? <Employees />
                : <ErrorNotFound />
            } />

          <Route
            path="/create_employees"
            element={
              roles['Employees'] &&
                (roles['Employees'] === "Edit")
                ? <Employees />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/edit_employees/:id"
            element={
              roles['Employees'] &&
                (roles['Employees'] === "Edit")
                ? <Employees />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_employees/:id"
            element={
              roles['Employees'] &&
                (roles['Employees'] === "Edit" || roles['Employees'] === "View")
                ? <Employees />
                : <ErrorNotFound />
            }
          />
          <Route exact
            path="/myDrives"
            element={
              roles['MyDrives'] &&
                (roles['MyDrives'] === "Edit" || roles['MyDrives'] === "View")
                ? <MyDrives />
                : <ErrorNotFound />
            } />

          <Route
            path="/create_myDrives"
            element={
              roles['MyDrives'] &&
                (roles['MyDrives'] === "Edit")
                ? <MyDrives />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/edit_myDrives/:id"
            element={
              roles['MyDrives'] &&
                (roles['MyDrives'] === "Edit")
                ? <MyDrives />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_myDrives/:id"
            element={
              roles['MyDrives'] &&
                (roles['MyDrives'] === "Edit" || roles['MyDrives'] === "View")
                ? <MyDrives />
                : <ErrorNotFound />
            }
          />
          <Route exact
            path="/users"
            element={
              roles['Users'] &&
                (roles['Users'] === "Edit" || roles['Users'] === "View")
                ? <Employees />
                : <ErrorNotFound />
            } />

          <Route
            path="/create_users"
            element={
              roles['Users'] &&
                (roles['Users'] === "Edit")
                ? <Employees />
                : <ErrorNotFound />
            }
          />
          <Route
            path="/edit_users/:id"
            element={
              roles['Users'] &&
                (roles['Users'] === "Edit")
                ? <Employees />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_users/:id"
            element={
              roles['Users'] &&
                (roles['Users'] === "Edit" || roles['Users'] === "View")
                ? <Employees />
                : <ErrorNotFound />
            }
          />
          <Route exact
            path="/tickets"
            element={
              roles['Tickets'] &&
                (roles['Tickets'] === "Edit" || roles['Tickets'] === "View")
                ? <Tickets />
                : <ErrorNotFound />
            } />

          <Route
            path="/create_tickets"
            element={
              roles['Tickets'] &&
                (roles['Tickets'] === "Edit")
                ? <Tickets />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/edit_tickets/:id"
            element={
              roles['Tickets'] &&
                (roles['Tickets'] === "Edit")
                ? <Tickets />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_tickets/:id"
            element={
              roles['Tickets'] &&
                (roles['Tickets'] === "Edit" || roles['Tickets'] === "View")
                ? <Tickets />
                : <ErrorNotFound />
            }
          />
          <Route exact
            path="/publicAi"
            element={
              roles['Public AI Assistant'] &&
                (roles['Public AI Assistant'] === "Edit" || roles['Public AI Assistant'] === "View")
                ? <PublicAi />
                : <ErrorNotFound />
            } />

          <Route exact
            path="/publicAi/:chatId"
            element={
              roles['Public AI Assistant'] &&
                (roles['Public AI Assistant'] === "Edit" || roles['Public AI Assistant'] === "View")
                ? <PublicAi />
                : <ErrorNotFound />
            } />

          <Route
            path="/create_publicAi"
            element={
              roles['Public AI Assistant'] &&
                (roles['Public AI Assistant'] === "Edit")
                ? <PublicAi />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/edit_publicAi/:id"
            element={
              roles['Public AI Assistant'] &&
                (roles['Public AI Assistant'] === "Edit")
                ? <PublicAi />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_publicAi/:id"
            element={
              roles['Public AI Assistant'] &&
                (roles['Public AI Assistant'] === "Edit" || roles['Public AI Assistant'] === "View")
                ? <PublicAi />
                : <ErrorNotFound />
            }
          />

          <Route exact
            path="/privateAi"
            element={
              roles['Private AI Assistant'] &&
                (roles['Private AI Assistant'] === "Edit" || roles['Private AI Assistant'] === "View")
                ? <Search />
                : <ErrorNotFound />
            } />

          <Route exact
            path="/privateAi/:chatId"
            element={
              roles['Private AI Assistant'] &&
                (roles['Private AI Assistant'] === "Edit" || roles['Private AI Assistant'] === "View")
                ? <Search />
                : <ErrorNotFound />
            } />

          <Route
            path="/create_privateAi"
            element={
              roles['Private AI Assistant'] &&
                (roles['Private AI Assistant'] === "Edit")
                ? <Search />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/edit_privateAi/:id"
            element={
              roles['Private AI Assistant'] &&
                (roles['Private AI Assistant'] === "Edit")
                ? <Search />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_privateAi/:id"
            element={
              roles['Private AI Assistant'] &&
                (roles['Private AI Assistant'] === "Edit" || roles['Private AI Assistant'] === "View")
                ? <Search />
                : <ErrorNotFound />
            }
          />

          <Route exact
            path="/homes"
            element={
              roles['Home'] &&
                (roles['Home'] === "Edit" || roles['Home'] === "View")
                ? <HomeNews />  //<Dashboard />
                : <ErrorNotFound />
            } />

          {/* <Route
            path="/create_homes"
            element={
              roles['Home'] &&
                (roles['Home'] === "Edit")
                ? <HomeNews />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/edit_homes/:id"
            element={
              roles['Home'] &&
                (roles['Home'] === "Edit")
                ? <HomeNews />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_homes/:id"
            element={
              roles['Home'] &&
                (roles['Home'] === "Edit" || roles['Home'] === "View")
                ? <HomeNews />
                : <ErrorNotFound />
            }
          /> */}

          <Route exact
            path="/translations"
            element={
              roles['Private AI Assistant'] &&
                (roles['Private AI Assistant'] === "Edit" || roles['Private AI Assistant'] === "View")
                ? <TranslateFiles />
                : <ErrorNotFound />
            } />

          <Route exact
            path="/comparefiles"
            element={
              roles['Private AI Assistant'] &&
                (roles['Private AI Assistant'] === "Edit" || roles['Private AI Assistant'] === "View")
                ? <CompareFiles />
                : <ErrorNotFound />
            } />



          <Route exact
            path="/myDocuments"
            element={

              <Homes />
            } />

          <Route
            path="/create_homes"
            element={
              roles['HoMy Documentsme'] &&
                (roles['My Documents'] === "Edit")
                ? <Homes />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/edit_homes/:id"
            element={
              roles['My Documents'] &&
                (roles['My Documents'] === "Edit")
                ? <Homes />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_homes/:id"
            element={
              roles['My Documents'] &&
                (roles['My Documents'] === "Edit" || roles['My Documents'] === "View")
                ? <Homes />
                : <ErrorNotFound />
            }
          />


          <Route exact
            path="/files"
            element={
              roles['Files'] &&
                (roles['Files'] === "Edit" || roles['Files'] === "View")
                ? <Files />
                : <ErrorNotFound />
            } />

          <Route
            path="/create_files"
            element={
              roles['Files'] &&
                (roles['Files'] === "Edit")
                ? <Files />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/edit_files/:id"
            element={
              roles['Files'] &&
                (roles['Files'] === "Edit")
                ? <Files />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_files/:id"
            element={
              roles['Files'] &&
                (roles['Files'] === "Edit" || roles['Files'] === "View")
                ? <Files />
                : <ErrorNotFound />
            }
          />
          <Route exact
            path="/folders"
            element={
              roles['Folders'] &&
                (roles['Folders'] === "Edit" || roles['Folders'] === "View")
                ? <Folders />
                : <ErrorNotFound />
            } />

          <Route
            path="/create_folders"
            element={
              roles['Folders'] &&
                (roles['Folders'] === "Edit")
                ? <Folders />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/edit_folders/:id"
            element={
              roles['Folders'] &&
                (roles['Folders'] === "Edit")
                ? <Folders />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_folders/:id"
            element={
              roles['Folders'] &&
                (roles['Folders'] === "Edit" || roles['Folders'] === "View")
                ? <Folders />
                : <ErrorNotFound />
            }
          />
          <Route exact
            path="/sharedFiles"
            element={
              roles['Shared With Me'] &&
                (roles['Shared With Me'] === "Edit" || roles['Shared With Me'] === "View")
                ? <SharedFiles />
                : <ErrorNotFound />
            } />

          <Route
            path="/create_sharedFiles"
            element={
              roles['Shared With Me'] &&
                (roles['Shared With Me'] === "Edit")
                ? <SharedFiles />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/edit_sharedFiles/:id"
            element={
              roles['Shared With Me'] &&
                (roles['Shared With Me'] === "Edit")
                ? <SharedFiles />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/view_sharedFiles/:id"
            element={
              roles['Shared With Me'] &&
                (roles['Shared With Me'] === "Edit" || roles['Shared With Me'] === "View")
                ? <SharedFiles />
                : <ErrorNotFound />
            }
          />

          {/* <Route exact
        id="employee"
        path="/employees"
        element={
          roles['Employees'] &&
            (roles['Employees'] === "Edit" || roles['Employees'] === "View")
            ? <Employees />
            : <ErrorNotFound />
        } />

      <Route
        id="create-employee"
        path="/create_employees"
        element={
          roles['Employees'] &&
            (roles['Employees'] === "Edit")
            ? <Employees/>
            : <ErrorNotFound />
        }
      />

      <Route
        id="edit-employee"
        path="/edit_employees/:id"
        element={
          roles['Employees'] &&
            (roles['Employees'] === "Edit")
            ? <Employees  />
            : <ErrorNotFound />
        }
      />

      <Route
        key="view-employee"
        path="/view_employees/:id"
        element={
          roles['Employees'] &&
            (roles['Employees'] === "Edit" || roles['Employees'] === "View")
            ? <Employees  />
            : <ErrorNotFound />
        }
      /> */}

          {/* <Route path="/settings" element={Settings} /> */}
          {/* <Route path="/adminSettings" element={AdminSettings} /> */}
          <Route
            path="/adminSettings"
            element={
              config.displaySettings
                ? <AdminSettings />
                : <ErrorNotFound />
            }
          />
          <Route
            path="/uploads"
            element={
              roles["Upload Histories"] &&
                (roles["Upload Histories"] === "Edit" || roles["Upload Histories"] === "View")
                ? <Uploads />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/activities"
            element={
              roles["Activities"] &&
                (roles["Activities"] === "Edit" || roles["Activities"] === "View")
                ? <Activities />
                : <ErrorNotFound />
            }
          />
          <Route
            path="/trash"
            element={
              roles["My Documents"] &&
                (roles["My Documents"] === "Edit" || roles["My Documents"] === "View")
                ? <Trash />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/roles"
            element={
              roles["Roles"] &&
                (roles["Roles"] === "Edit" || roles["Roles"] === "View")
                ? <Roles />
                : <ErrorNotFound />
            }
          />
          <Route
            path="/create_roles"
            element={
              roles["Roles"] &&
                (roles["Roles"] === "Edit")
                ? <Roles />
                : <ErrorNotFound />
            }
          />
          <Route
            path="/edit_roles/:id"
            element={
              roles["Roles"] &&
                (roles["Roles"] === "Edit")
                ? <Roles />
                : <ErrorNotFound />
            }
          />
          <Route
            path="/view_roles/:id"
            element={
              roles["Roles"] &&
                (roles["Roles"] === "Edit" || roles["Roles"] === "View")
                ? <Roles />
                : <ErrorNotFound />
            }
          />
          <Route
            path="/emailStatuses"
            element={
              roles["Email Statuses"] &&
                (roles["Email Statuses"] === "Edit" || roles["Email Statuses"] === "View")
                ? <EmailStatus />
                : <ErrorNotFound />
            }
          />

          <Route
            path="/templates"
            element={
              roles["Email Templates"] &&
                (roles["Email Templates"] === "Edit" || roles["Email Templates"] === "View")
                ? <EmailTemplate />
                : <ErrorNotFound />
            }
          />
          <Route
            path="/create_templates"
            element={
              roles["Email Templates"] &&
                (roles["Email Templates"] === "Edit")
                ? <EmailTemplate />
                : <ErrorNotFound />
            }
          />
          <Route
            path="/edit_templates/:id"
            element={
              roles["Email Templates"] &&
                (roles["Email Templates"] === "Edit")
                ? <EmailTemplate />
                : <ErrorNotFound />
            }
          />
          <Route
            path="/view_templates/:id"
            element={
              roles["Email Templates"] &&
                (roles["Email Templates"] === "Edit" || roles["Email Templates"] === "View")
                ? <EmailTemplate />
                : <ErrorNotFound />
            }
          />
          <Route exact
            id="scribe"
            path="/speech"
            element={
              roles['Scribe'] &&
                (roles['Scribe'] === "Edit" || roles['Scribe'] === "View")
                ? <Recordings />
                : <ErrorNotFound />
            } />

          <Route exact
            path="/clients"
            element={
              roles['Clients'] &&
                (roles['Clients'] === "Edit" || roles['Clients'] === "View")
                ? <Clients />
                : <ErrorNotFound />
            } />
          <Route exact
            path="/testCases"
            element={
              roles['Test Cases'] &&
                (roles['Test Cases'] === "Edit" || roles['Test Cases'] === "View")
                ? <TestCaseGenerator />
                : <ErrorNotFound />
            } />

          <Route exact
            id="topic"
            path="/topics"
            element={
              roles['Generate Content'] &&
                (roles['Generate Content'] === "Edit" || roles['Generate Content'] === "View")
                ? <ContentGeneration />
                : <ErrorNotFound />
            } />

          <Route exact
            id="filesAnalysis"
            path="/filesAnalysis"
            element={
              roles['Files Analysis'] &&
                (roles['Files Analysis'] === "Edit" || roles['Files Analysis'] === "View")
                ? <FilesAnalysis />
                : <ErrorNotFound />
            } />
          <Route
            path="/trackingCustomer"
            element={<TrackingCustomer />}
          />
          <Route
            path="/Reconciliation"
            element={<PaymentDocumentation />}
          />

          <Route exact
            id="invoice"
            path="/invoices"
            element={
              <Invoices />
            } />

          <Route exact
            id="priceChangeTracker"
            path="/priceChangeTracker"
            element={
              <PriceChangeTracker />
            } />

          <Route exact
            id="company"
            path="/company"
            element={
              <Company />
            } />


          <Route exact
            id="uniqueCases"
            path="/uniqueCases"
            element={
              <UniqueCases />
              // roles['UniqueCases'] &&
              //   (roles['UniqueCases'] === "Edit" || roles['UniqueCases'] === "View")
              // ? <Company />
              // : <ErrorNotFound />
            } />


          <Route exact
            id="casePredictAI"
            path="/casePredictAI"
            element={
              <CasePredictAI />
            } />


          <Route exact
            path="/agreementTemplates"
            element={<AgreementFiles />}
          />

          <Route exact
            path="/smartScreenBuilder"
            element={<SmartScreenBuilder />}
          />
          <Route exact
            path="/smartScreens/:screen"
            element={<SmartScreen />}
          />



          <Route exact
            id="contracts"
            path="/contracts"
            element={
              <Contracts />
            } />



          {/* <Route path="/uploads" element={Uploads} />
    <Route path="/activities" element={Activities} />
    <Route path="/roles" element={Roles} />
    <Route path="/templates" element={EmailTemplate} /> */}
        </Routes >
        <Outlet />
      </>
    )
  }
}

const Account = () => (
  <Routes>
    <Route path="/changepassword" element={<ChangePassword />} />
    <Route path="/profile" element={<Profile />} />

  </Routes>

);

const WrappedRoutes = () => {
  let loginCredentials = localStorage.loginCredentials ? JSON.parse(localStorage.loginCredentials) : false;
  const { showChatbot, setShowChatbot } = useChatbot();

  if (loginCredentials) {
    return <div>
      <Layout showChatbot={showChatbot} setShowChatbot={setShowChatbot} />
      <div className="container__wrap" >
        <Routes>
          {/* <Route path="/" element={<Account />} /> */}
          <Route path="/*" index={true} element={<Tables />} />
          <Route path="/changepassword" element={<ChangePassword />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/dashBoard" element={<Home />} />
        </Routes>
      </div>

      <Outlet />
    </div>
  }
  else {
    return <ErrorNotFound />
  }
}

const Router = () => (
  <MainWrapper>
    <main>
      <Routes>
        <Route path="/changeRecoverPassword/:enEmail" element={<ChangeRecoverPassword />} />
        <Route path="/loginChangePassword" element={<LoginChangePassword />} />
        <Route exact path="/" element={<Landing />} />
        <Route path="/log_in" element={<Landing />} />
        <Route path="/logout" element={<Landing />} />
        <Route path="/two_step_verification" element={<Verification />} />
        <Route path="/authenticator" element={<GoogleAuthenticator />} />
        <Route path="/verify_authenticator" element={<VerifyGoogleAuthenticator />} />
        <Route path="/forgot_password" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />
        <Route path="/share/:chatId" element={<ShareChat />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/*" element={<WrappedRoutes />} />
        <Route element={<ErrorNotFound />} />


      </Routes>
      <Outlet />
    </main>
  </MainWrapper>
);

export default Router;